export default "__VITE_ASSET__DV24rTaI__"